import { Component, Input, ElementRef, AfterViewInit, ViewChild } from "@angular/core";
import { IUProperty } from "src/app/shared/interface/umbraco-property";
import { IPricesTableCategoryItem } from "./components/prices-table-category-item/prices-table-category-item.component";
import { IPricesTableLicenseItem } from "./components/prices-table-license-item/prices-table-license-item.component";
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
import { ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { IRteStyleSettings } from "../../shared/interface/rte-style-settings";
import { applyRteSettings } from "../../shared/utils/rte-style-settings-utils";

interface IPricesTablePanelData {
  categories: IUProperty<IPricesTableCategoryItem[]>;
  title: IUProperty<string>;
  description: IUProperty<string>;
  licenses: IUProperty<IPricesTableLicenseItem[]>;
  anchor: IUProperty<string>;

  rteStyleSettings?: IRteStyleSettings;
  titleStyleSettings?: ITitleStyleSettings;
}

@Component({
  selector: "app-prices-table-panel",
  templateUrl: "./prices-table-panel.component.html",
  styleUrls: ["./prices-table-panel.component.less"],
})
export class PricesTablePanelComponent implements AfterViewInit {
  @Input() data: IPricesTablePanelData;
  @ViewChild('titleEl', { static: false }) titleEl: ElementRef<HTMLElement>; 
  @ViewChild('descriptionEl', { static: false }) descriptionEl: ElementRef<HTMLElement>;

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    applyTitleSettings(this.data, this.titleEl);
    applyRteSettings(this.data, this.descriptionEl);
  }
}
